import { Chip, Divider, Stack, Typography } from '@mui/material'
import { memo } from 'react'

import { ChangeLogActionType, ChangeLogType } from 'src/types/ChangelogType'

function formatTypeLabel(type: ChangeLogActionType) {
  switch (type) {
    case 'added':
      return "What's New"
    case 'fixed':
      return 'Improvements & Fixes'
    case 'changed':
      return 'What Changed'
    case 'removed':
      return 'What Removed'
    case 'security':
      return 'Security Updates'
    case 'deprecated':
      return 'Deprecated'
    default:
      return type
  }
}

export default memo(function ChangelogItem(data: ChangeLogType) {
  const showTags = data.tags && data.tags.length > 0
  return (
    <Stack
      p={2}
      border="1px solid #eee"
      borderRadius={1.8}
      gap={1}
      sx={{ '&:hover': { borderColor: '#ccc' }, transition: 'all 0.3s ease', userSelect: 'none', cursor: 'pointer' }}
    >
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Typography variant="body2" color="textSecondary">
          v.{data.version}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {new Date(data.publishedAt).toLocaleDateString('en-US', { dateStyle: 'medium' })}
        </Typography>
      </Stack>
      <Stack gap={0.5}>
        <Typography variant="h6">{data.title}</Typography>
        {data.description ? <Typography>{data.description}</Typography> : null}
        {showTags ? (
          <Stack direction={'row'} flexWrap={'wrap'} gap={1} mt={1}>
            {data.tags?.map((t) => <Chip key={t} label={t} size="small" />)}
          </Stack>
        ) : null}
      </Stack>
      <Stack component={'section'} gap={1.5} py={2}>
        {data.changes.map((change, index) => (
          <Stack key={index} gap={1}>
            <Typography fontWeight={600} textTransform={'capitalize'}>
              {formatTypeLabel(change.type)}
            </Typography>
            <Stack pl={3}>
              {change.items.map((item, idx) => (
                <li key={idx}>
                  <Typography>{item}</Typography>
                </li>
              ))}
            </Stack>
          </Stack>
        ))}
      </Stack>
      <Divider />
      <Typography variant="body2" color="textSecondary" mt={0.5} textAlign={'right'}>
        {data.author?.name || 'Unknown Author'}
      </Typography>
    </Stack>
  )
})
